// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3pY7M","title":"Images45_title__2sYKQ","images":"Images45_images__2h8N6"};